const contactDefault = [
  { type: 'community', priority: '1' },
  { type: 'resolution', priority: '2' },
  { type: 'business', priority: '3' },
  { type: 'tax', priority: '4' },
  { type: 'contact', priority: '5' },
];

const contactTechnical = [
  { type: 'community', priority: '1' },
  { type: 'developer', priority: '2' },
  { type: 'braintree', priority: '3' },
  { type: 'site', priority: '4' },
  { type: 'contact', priority: '5' },
];

module.exports = {
  contactDefault,
  contactTechnical,
};
